<template>
  <div class="dropdown"
       :class="selector"
  >
    <button class="dropdown__trigger"
       @click.prevent="onToggleTrigger"
    >
      <span>{{currentLanguage.show_code}}</span>
      <i class="dropdown__arrow fa fa-angle-down"></i>
    </button>
    <transition :name="toTop ? 'dropdown-top' : 'dropdown'">
      <div
        v-if="isOpen"
        v-click-out="onClose"
        class="dropdown__toggle"
      >
        <div class="dropdown__options-list">
          <router-link v-for="language in languages"
                       :key="language.id"
                       :to="{params: {locale: language.show_code}}"
                       :style="{backgroundImage: language.image}"
                       class="dropdown__option">
            {{language.show_code}}
          </router-link>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
  import {languages} from '@/i18n'

  export default {
    name: 'LangSelect',
    props: {
      toTop: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        isOpen: false,
        languages
      }
    },
    computed: {
      selector() {
        return {
          '_open': this.isOpen,
          '_top': this.toTop
        }
      },
      currentLanguage() {
        return languages.find(language => language.show_code === this.$route.params.locale) || {}
      }
    },
    methods: {
      onToggleTrigger() {
        this.isOpen = !this.isOpen
      },
      onClose() {
        this.isOpen = false
      }
    },
    watch: {
      '$route.params.locale'() {
        this.onClose()
      }
    }
  }
</script>

<style scoped lang="less">
  .dropdown {
    text-transform: uppercase;
    &__trigger {
      text-transform: inherit;
    }
  }
</style>
